import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult } from '../../types';
export default async function goodWholesaleGet(context: Context, parms: CustomQuery): Promise<ApiResult> {
  // const url = new URL('/mall/article/get', context.config.api.url);
  const url = new URL('/mall/good/wholesale/get', context.config.api.url);
  const { data: res } = await context.client.post(url.href, parms);
  return res;
}
